/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CustomersSubscriptionsChangePlanGet200ResponseOneOf from './CustomersSubscriptionsChangePlanGet200ResponseOneOf';
import CustomersSubscriptionsChangePlanGet200ResponseOneOf1 from './CustomersSubscriptionsChangePlanGet200ResponseOneOf1';

/**
 * The CustomersSubscriptionsChangePlanGet200Response model module.
 * @module model/CustomersSubscriptionsChangePlanGet200Response
 * @version 1.0.0
 */
class CustomersSubscriptionsChangePlanGet200Response {
    /**
     * Constructs a new <code>CustomersSubscriptionsChangePlanGet200Response</code>.
     * @alias module:model/CustomersSubscriptionsChangePlanGet200Response
     * @param {(module:model/CustomersSubscriptionsChangePlanGet200ResponseOneOf|module:model/CustomersSubscriptionsChangePlanGet200ResponseOneOf1)} instance The actual instance to initialize CustomersSubscriptionsChangePlanGet200Response.
     */
    constructor(instance = null) {
        if (instance === null) {
            this.actualInstance = null;
            return;
        }
        var match = 0;
        var errorMessages = [];
        try {
            if (typeof instance === "CustomersSubscriptionsChangePlanGet200ResponseOneOf") {
                this.actualInstance = instance;
            } else {
                // plain JS object
                // validate the object
                CustomersSubscriptionsChangePlanGet200ResponseOneOf.validateJSON(instance); // throw an exception if no match
                // create CustomersSubscriptionsChangePlanGet200ResponseOneOf from JS object
                this.actualInstance = CustomersSubscriptionsChangePlanGet200ResponseOneOf.constructFromObject(instance);
            }
            match++;
        } catch(err) {
            // json data failed to deserialize into CustomersSubscriptionsChangePlanGet200ResponseOneOf
            errorMessages.push("Failed to construct CustomersSubscriptionsChangePlanGet200ResponseOneOf: " + err)
        }

        try {
            if (typeof instance === "CustomersSubscriptionsChangePlanGet200ResponseOneOf1") {
                this.actualInstance = instance;
            } else {
                // plain JS object
                // validate the object
                CustomersSubscriptionsChangePlanGet200ResponseOneOf1.validateJSON(instance); // throw an exception if no match
                // create CustomersSubscriptionsChangePlanGet200ResponseOneOf1 from JS object
                this.actualInstance = CustomersSubscriptionsChangePlanGet200ResponseOneOf1.constructFromObject(instance);
            }
            match++;
        } catch(err) {
            // json data failed to deserialize into CustomersSubscriptionsChangePlanGet200ResponseOneOf1
            errorMessages.push("Failed to construct CustomersSubscriptionsChangePlanGet200ResponseOneOf1: " + err)
        }

        if (match > 1) {
            throw new Error("Multiple matches found constructing `CustomersSubscriptionsChangePlanGet200Response` with oneOf schemas CustomersSubscriptionsChangePlanGet200ResponseOneOf, CustomersSubscriptionsChangePlanGet200ResponseOneOf1. Input: " + JSON.stringify(instance));
        } else if (match === 0) {
            this.actualInstance = null; // clear the actual instance in case there are multiple matches
            throw new Error("No match found constructing `CustomersSubscriptionsChangePlanGet200Response` with oneOf schemas CustomersSubscriptionsChangePlanGet200ResponseOneOf, CustomersSubscriptionsChangePlanGet200ResponseOneOf1. Details: " +
                            errorMessages.join(", "));
        } else { // only 1 match
            // the input is valid
        }
    }

    /**
     * Constructs a <code>CustomersSubscriptionsChangePlanGet200Response</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersSubscriptionsChangePlanGet200Response} obj Optional instance to populate.
     * @return {module:model/CustomersSubscriptionsChangePlanGet200Response} The populated <code>CustomersSubscriptionsChangePlanGet200Response</code> instance.
     */
    static constructFromObject(data, obj) {
        return new CustomersSubscriptionsChangePlanGet200Response(data);
    }

    /**
     * Gets the actual instance, which can be <code>CustomersSubscriptionsChangePlanGet200ResponseOneOf</code>, <code>CustomersSubscriptionsChangePlanGet200ResponseOneOf1</code>.
     * @return {(module:model/CustomersSubscriptionsChangePlanGet200ResponseOneOf|module:model/CustomersSubscriptionsChangePlanGet200ResponseOneOf1)} The actual instance.
     */
    getActualInstance() {
        return this.actualInstance;
    }

    /**
     * Sets the actual instance, which can be <code>CustomersSubscriptionsChangePlanGet200ResponseOneOf</code>, <code>CustomersSubscriptionsChangePlanGet200ResponseOneOf1</code>.
     * @param {(module:model/CustomersSubscriptionsChangePlanGet200ResponseOneOf|module:model/CustomersSubscriptionsChangePlanGet200ResponseOneOf1)} obj The actual instance.
     */
    setActualInstance(obj) {
       this.actualInstance = CustomersSubscriptionsChangePlanGet200Response.constructFromObject(obj).getActualInstance();
    }

    /**
     * Returns the JSON representation of the actual instance.
     * @return {string}
     */
    toJSON = function(){
        return this.getActualInstance();
    }

    /**
     * Create an instance of CustomersSubscriptionsChangePlanGet200Response from a JSON string.
     * @param {string} json_string JSON string.
     * @return {module:model/CustomersSubscriptionsChangePlanGet200Response} An instance of CustomersSubscriptionsChangePlanGet200Response.
     */
    static fromJSON = function(json_string){
        return CustomersSubscriptionsChangePlanGet200Response.constructFromObject(JSON.parse(json_string));
    }
}

/**
 * @member {String} message
 */
CustomersSubscriptionsChangePlanGet200Response.prototype['message'] = undefined;

/**
 * @member {String} email
 */
CustomersSubscriptionsChangePlanGet200Response.prototype['email'] = undefined;

/**
 * @member {String} customerId
 */
CustomersSubscriptionsChangePlanGet200Response.prototype['customerId'] = undefined;

/**
 * @member {String} subscriptionId
 */
CustomersSubscriptionsChangePlanGet200Response.prototype['subscriptionId'] = undefined;

/**
 * @member {Boolean} hasPendingChangePlan
 */
CustomersSubscriptionsChangePlanGet200Response.prototype['hasPendingChangePlan'] = undefined;

/**
 * @member {String} currentBundle
 */
CustomersSubscriptionsChangePlanGet200Response.prototype['currentBundle'] = undefined;

/**
 * @member {String} targetBundle
 */
CustomersSubscriptionsChangePlanGet200Response.prototype['targetBundle'] = undefined;


CustomersSubscriptionsChangePlanGet200Response.OneOf = ["CustomersSubscriptionsChangePlanGet200ResponseOneOf", "CustomersSubscriptionsChangePlanGet200ResponseOneOf1"];

export default CustomersSubscriptionsChangePlanGet200Response;

